export const toollist =  [
    {
        "Type": "Button",
        "Label": "Editer",
        "Color": "accent",
        "Icon": "edit",
        "Method": "edit"
    },
    {
        "Type": "Button",
        "Label": "Supprimer",
        "Color": "warn",
        "Icon": "delete",
        "Method": "delete"
    },
    {
        "Type": "Link",
        "Label": "Retour",
        "Color": "disabled",
        "Icon": "arrow_back_ios",
        "Link": ['/','incidents'],
    }
];